export default __webpack_public_path__ + "static/media/logo4.4be4562b.svg";